import { __rest, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
import styles from '../../components/base/HorizonForm/index.module.scss.js';
import classNames from './../../external_lib/classnames/index.js';
import AntForm from './../../external_lib/antd/es/form/index.js';
var AntFormItem = AntForm.Item;
function HorizonForm(_a) {
  var children = _a.children,
    _b = _a.layout,
    layout = _b === void 0 ? 'vertical' : _b,
    className = _a.className,
    restProps = __rest(_a, ["children", "layout", "className"]);
  return React__default.createElement(AntForm, __assign({
    layout: layout,
    className: classNames(className)
  }, restProps), children);
}
function HorizonFormItem(_a) {
  var children = _a.children,
    _b = _a.layout,
    layout = _b === void 0 ? 'vertical' : _b,
    className = _a.className,
    restProps = __rest(_a, ["children", "layout", "className"]);
  return React__default.createElement(AntFormItem, __assign({
    className: classNames(styles.horizonFormItem, className),
    layout: layout
  }, restProps), children);
}
HorizonForm.Item = HorizonFormItem;
HorizonForm.List = AntForm.List;
HorizonForm.ErrorList = AntForm.ErrorList;
HorizonForm.Provider = AntForm.Provider;
HorizonForm.useForm = AntForm.useForm;
HorizonForm.useFormInstance = AntForm.useFormInstance;
HorizonForm.useWatch = AntForm.useWatch;
export { HorizonForm as default };
//# sourceMappingURL=index.js.map
